/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, { useState, useEffect } from 'react';
import {useParams} from "react-router-dom";
import PageBox from "../../layouts/pageBox";
import PageHeader from "../../layouts/PageHeader";
import Loader from "../../elements/loader";
import AccordionPartsAll from "../../elements/_AccordionPartsAll";
import AccordionParts from "../../elements/AccordionParts";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";

const PartsCategoriesAll = () => {

    let params = useParams();
    const { t, i18n } = useTranslation();

    const [searchValue, setSearchValue] = useState("");
    const [parts, setParts] = useState({isLoading: true, data: [], error: false});
    const [isLoading, setLoading] = useState(true);
    const [allOpen, setAllOpen] = useState(false);

    const axiosJWT = useAxiosJTW();

    const [headerData, setHeaderData] = useState({
        title : '',
        description : '',
        logo: ''
    });

    const data = {
        title: t('parts.listingTitle'),
        subtitle: t('parts.listingSubtitle'),
    };

    const getpartscategories = (signal) => {
        axiosJWT.post('api/getpartsbymodel', { type: 'all'},{signal}).then( (response) => {
            if(response.status === 200){

                setParts({...parts, data: response.data.part_categories|| [], isLoading: false});
                setHeaderData({
                    title : `Used parts`,
                    subtitle : null,
                    logo: response.data.logo,
                });
            }
        } ).catch((error) => {
            setParts({...parts, isLoading: true, error: true});
        });

    }

    function updateOpen(data){
        setAllOpen(data);
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getpartscategories(signal);

        return () => {controller.abort();}
    }, [params]);

    return (
        <PageBox data={data} showAdds={true}>
            <SEO
                title={t('meta_title.partsCategoriesAll')}
                description={t('meta_description.partsCategoriesAll')}
            />
            <div className='page-header'>
                <PageHeader data={headerData} onSearch={setSearchValue} value={searchValue} onUpdateSearch={updateOpen}/>
            </div>
            <div className='page-body'>
                {parts.isLoading ? (
                    <>
                        <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                        {parts.error &&<div style={{ paddingTop: '30px', textAlign : 'center', color: 'red' }}>{t('parts.reqerror')}</div>}
                    </>
                ) : (
                    parts.data.map((item, index) => {
                        return (
                            <AccordionParts part={item} key={index} search={searchValue} isallOpen={allOpen} link={`/${i18n.language}/parts/categories/slug?spec=value`}/>
                        );
                    })
                )}
            </div>
        </PageBox>
    );
};

export default PartsCategoriesAll;
